(() => {
  if (window.__tmShippingProtectionLoaded) return;
  window.__tmShippingProtectionLoaded = true;

  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const rootUrl = () => window.Shopify?.routes?.root || '/';

  async function postCart(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ ...body, sections, sections_url: window.location.pathname }),
    });
    const payload = await response.json();
    if (!response.ok || payload?.status) throw new Error(payload?.description || payload?.message || 'Cart update failed.');
    return payload;
  }

  function render(payload) {
    const drawer = document.querySelector('cart-drawer');
    if (payload?.sections && drawer?.renderContents) {
      const drawerHtml = payload.sections['cart-drawer'] || '';
      drawer.classList.toggle('is-empty', drawerHtml.includes('class="drawer is-empty"'));
      drawer.renderContents(payload);
    }
    else window.location.reload();
  }

  if (!customElements.get('shipping-protection-toggle')) {
    customElements.define('shipping-protection-toggle', class ShippingProtectionToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-sp-toggle]');
        this.variantId = Number(this.dataset.variantId);
        this.lineKey = this.dataset.lineKey || '';
        this.lineQuantity = Number(this.dataset.lineQuantity || 0);
        this.mainItemCount = Number(this.dataset.mainItemCount || 0);
        this.storageKey = this.dataset.storageKey;
        this.input?.addEventListener('change', () => this.change());
        this.reconcile();
      }

      get explicitlyOff() {
        return localStorage.getItem(this.storageKey) === 'off';
      }

      loading(active) {
        this.classList.toggle('is-loading', active);
        if (this.input) this.input.disabled = active;
      }

      async reconcile() {
        if (!this.variantId || this.dataset.reconciling === 'true') return;
        this.dataset.reconciling = 'true';
        try {
          if (this.mainItemCount === 0 && this.lineKey) {
            this.loading(true);
            const payload = await postCart(window.routes?.cart_change_url || rootUrl() + 'cart/change.js', { id: this.lineKey, quantity: 0 });
            render(payload);
          } else if (this.mainItemCount === 0) {
            return;
          } else if (this.lineKey && this.lineQuantity !== 1) {
            this.loading(true);
            const payload = await postCart(window.routes?.cart_change_url || rootUrl() + 'cart/change.js', { id: this.lineKey, quantity: 1 });
            render(payload);
          } else if (!this.lineKey && !this.explicitlyOff) {
            this.loading(true);
            if (this.input) this.input.checked = true;
            const payload = await postCart(window.routes?.cart_add_url || rootUrl() + 'cart/add.js', {
              items: [{ id: this.variantId, quantity: 1, properties: { _shipping_protection: 'true' } }],
            });
            render(payload);
          }
        } catch (error) {
          if (!this.lineKey && this.input) this.input.checked = false;
          this.loading(false);
          console.error(error);
        } finally {
          delete this.dataset.reconciling;
        }
      }

      async ensureOn() {
        if (this.explicitlyOff || this.lineKey) return;
        const payload = await postCart(window.routes?.cart_add_url || rootUrl() + 'cart/add.js', {
          items: [{ id: this.variantId, quantity: 1, properties: { _shipping_protection: 'true' } }],
        });
        render(payload);
      }

      async change() {
        const checked = this.input.checked;
        this.loading(true);
        try {
          const payload = checked
            ? await postCart(window.routes?.cart_add_url || rootUrl() + 'cart/add.js', { items: [{ id: this.variantId, quantity: 1, properties: { _shipping_protection: 'true' } }] })
            : await postCart(window.routes?.cart_change_url || rootUrl() + 'cart/change.js', { id: this.lineKey, quantity: 0 });
          if (checked) localStorage.removeItem(this.storageKey);
          else localStorage.setItem(this.storageKey, 'off');
          render(payload);
        } catch (error) {
          this.input.checked = !checked;
          this.loading(false);
          console.error(error);
        }
      }
    });
  }

  document.addEventListener('click', async (event) => {
    const checkout = event.target.closest?.('#CartDrawer-Checkout');
    const toggle = document.querySelector('shipping-protection-toggle');
    if (!checkout || !toggle || toggle.mainItemCount === 0 || toggle.explicitlyOff || toggle.lineKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.disabled = true;
    try {
      await toggle.ensureOn();
      window.location.assign(rootUrl() + 'checkout');
    } catch (error) {
      checkout.disabled = false;
      console.error(error);
    }
  }, true);
})();
